import React from 'react';
function DesignEffects({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M9 3L10.9799 8.0201L16 10L10.9799 11.9799L9 17L7.0201 11.9799L2 10L7.0201 8.0201L9 3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 13L18.1314 15.8686L21 17L18.1314 18.1314L17 21L15.8686 18.1314L13 17L15.8686 15.8686L17 13Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DesignEffects;
